module.exports = __webpack_public_path__ + "static/media/skoda.6bec5c05.png";